import { Button, Descriptions, Popover } from 'antd';

import type { ParentDetails } from './types';

const ParentDetailsCard = ({ parent }: { parent: ParentDetails }) => (
  <Descriptions column={1} size="small" style={{ maxWidth: 320 }}>
    <Descriptions.Item label="Хамаарал">{parent.relation ?? '—'}</Descriptions.Item>
    <Descriptions.Item label="Утас">
      {parent.phone ? <a href={`tel:${parent.phone}`}>{parent.phone}</a> : '—'}
    </Descriptions.Item>
    <Descriptions.Item label="И-мэйл">
      {parent.email ? <a href={`mailto:${parent.email}`}>{parent.email}</a> : '—'}
    </Descriptions.Item>
    <Descriptions.Item label="Гэрийн хаяг">{parent.home_address ?? '—'}</Descriptions.Item>
    <Descriptions.Item label="Facebook">{parent.facebook ?? '—'}</Descriptions.Item>
  </Descriptions>
);

// A parent's name that opens their details on click; "—" without a parent.
const ParentLink = ({ name, parent }: { name: string | null; parent: ParentDetails | null }) =>
  parent ? (
    <Popover trigger="click" title={name} content={<ParentDetailsCard parent={parent} />}>
      <Button type="link" style={{ padding: 0, height: 'auto' }}>
        {name}
      </Button>
    </Popover>
  ) : (
    (name ?? '—')
  );

export default ParentLink;
